"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHotKeyHandler = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Helpers
var blacklistTargets = [];

var keysReducer = function keysReducer(state, action) {
  switch (action.type) {
    case "set-key-down":
      var keydownState = _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.key, true));

      return keydownState;

    case "set-key-up":
      var keyUpState = _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.key, false));

      return keyUpState;

    case "reset-keys":
      var resetState = _objectSpread({}, action.data);

      return resetState;

    default:
      return state;
  }
}; // Hot Keys Handler


var useHotKeyHandler = function useHotKeyHandler(shortcutKeys, callback) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = Object.assign({
    preventDefault: false
  }, opts); // Do some checks

  if (!Array.isArray(shortcutKeys)) {
    throw new Error("The first parameter to `useHotKeysHandler` must be an ordered array of `KeyboardEvent.key` strings.");
  }

  if (!shortcutKeys.length) {
    throw new Error("The first parameter to `useHotKeysHandler` must contain at least one `KeyboardEvent.key` string.");
  }

  if (typeof callback !== "function") {
    throw new Error("The second parameter to `useHotKeysHandler` must be a function that will be invoked when the keys are pressed.");
  }

  var initalKeyMapping = shortcutKeys.reduce(function (currentKeys, key) {
    currentKeys[key] = false;
    return currentKeys;
  }, {});

  var _useReducer = (0, _react.useReducer)(keysReducer, initalKeyMapping),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      keys = _useReducer2[0],
      setKeys = _useReducer2[1]; // Handler for keydown


  var keydownListener = (0, _react.useCallback)(function (keydownEvent) {
    var key = keydownEvent.key,
        target = keydownEvent.target,
        repeat = keydownEvent.repeat; // Make sure were not in input, textarea, etc.

    if (blacklistTargets.includes(target.tagName)) return; // Determine that it's a key we're listening for 

    if (!shortcutKeys.includes(key)) {
      return;
    } // prevent default if needed


    if (options.preventDefault) {
      keydownEvent.preventDefault();
    } // Double check we're not repeating


    if (repeat) {
      console.log('repeating keypress');
      return;
    }

    if (!keys[key]) {
      setKeys({
        type: "set-key-down",
        key: key
      });
    }
  }, [shortcutKeys, keys]); // Handler for keyup

  var keyupListener = (0, _react.useCallback)(function (keyupEvent) {
    var key = keyupEvent.key,
        target = keyupEvent.target; // Make sure were not in input, textarea, etc.

    if (blacklistTargets.includes(target.tagName)) return; // Determine that it's a key we're listening for  

    if (!shortcutKeys.includes(key)) {
      return;
    } // prevent default if needed


    if (options.preventDefault) {
      keyupEvent.preventDefault();
    }

    if (keys[key]) {
      setKeys({
        type: "set-key-up",
        key: key
      });
    }
  }, [shortcutKeys, keys, options]); // Listen to keydown events

  (0, _react.useEffect)(function () {
    document.addEventListener("keydown", keydownListener, true);
    return function () {
      return document.removeEventListener("keydown", keydownListener, true);
    };
  }, [keydownListener]); // Listen to keyup events

  (0, _react.useEffect)(function () {
    document.addEventListener("keyup", keyupListener, true);
    return function () {
      return document.removeEventListener("keyup", keyupListener, true);
    };
  }, [keyupListener]); // Run the callback!

  (0, _react.useEffect)(function () {
    if (!Object.values(keys).filter(function (value) {
      return !value;
    }).length) {
      callback(keys);
      setKeys({
        type: "reset-keys",
        data: initalKeyMapping
      });
    } else {
      setKeys({
        type: null
      });
    }
  }, [callback, keys, initalKeyMapping]);
};

exports.useHotKeyHandler = useHotKeyHandler;